import { jsonp } from '@ifeng/ui_base';
import { faceImgList } from './utils';
import styles from '../components/commentTextarea/commentTextareaBody/index.css';

const md5 = require('md5');

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    while (window[jsonpCallbackName]) {
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

// 获取用户 guid
const getGuid = async (sid) => {
    const guid = await jsonp('//id.ifeng.com/api/getuid', {
        data: {
            sid,
        },
        cache: true,
    });

    return guid;
};

// 解析表情
const resolveFace = (cmtContent) => {
    let newContent = cmtContent;
    const reg = /\[([^\]]*)\]/gim;
    const matchList = cmtContent.match(reg);
    const faceList0 = faceImgList.map((item) => item.title);
    const faceList1 = faceImgList.map((item) => item.name);

    if (matchList) {
        const len = matchList.length;

        for (let i = 0; i < len; i++) {
            const faceStr = matchList[i].replace('[', '').replace(']', '');
            const m = faceList0.indexOf(faceStr);
            const n = faceList1.indexOf(faceStr);

            const index = m === -1 ? n : m;

            let html = '';

            if (index > -1) {
                html = `<span class="${styles.face} ${styles[faceImgList[index].name]}"></span>`;
            }

            newContent = newContent.replace(matchList[i], html);
        }
    }

    return newContent;
};

/**
 * 翻转楼层数据
 * @param {Array} arr 楼层数据
 */
const reverseArr = (arr) => {
    const len = arr.length;
    const mid = Math.floor(len / 2);

    for (let i = 0; i < mid; i++) {
        const tmp = arr[i];

        arr[i] = arr[len - i - 1];
        arr[len - i - 1] = tmp;
    }

    return arr;
};

// 格式化评论数据
const formatHotListData = (data, limit) => {
    data.forEach((item) => {
        // 解析表情
        const content = item.comment_contents;

        item.contents = resolveFace(content);

        // 根据用户名过滤用户连接
        const uname = item.uname;

        if (uname === '客户端用户' || uname === '手机用户' || uname === '凤凰网友') {
            item.user_url = '';
        }

        // 处理时间
        const plTime = item.comment_date;

        item.year = plTime.substr(0, 4);
        item.date = plTime.substr(5, 2);
        item.time = plTime.substr(8, 8);

        // 解析楼层
        const parent = reverseArr(item.parent); // 翻转楼层信息
        const prtNum = parent.length;
        const basicParentList = []; // 基本楼层列表
        const moreParentList = []; // 隐藏楼层列表
        const floorLimit = limit; // 假设需求为，显示前5层，后5层隐藏
        const parentLimit = floorLimit < prtNum ? floorLimit : prtNum;

        // 将前5层评论内容放入basicParentList
        if (prtNum > 0) {
            for (let k = 0; k < parentLimit; k++) {
                const parentItem = parent[k];
                const time = parentItem.comment_date;

                parent[k].year = time.substr(0, 4);
                parent[k].date = time.substr(5, 2);
                parent[k].time = time.substr(8, 8);

                const commentContent = parentItem.comment_contents;

                parent[k].contents = resolveFace(commentContent);

                const uname = parentItem.uname;

                if (uname === '客户端用户' || uname === '手机用户' || uname === '凤凰网友') {
                    parent[k].user_url = '';
                }
                basicParentList.push(parent[k]);
            }
            item.basicParentList = basicParentList;
        }

        // 将后5层评论内容放入moreParentList
        if (prtNum > floorLimit) {
            for (let j = floorLimit; j < prtNum; j++) {
                const parentItem = parent[j];
                const time = parentItem.comment_date;

                parentItem.year = time.substr(0, 4);
                parentItem.date = time.substr(5, 2);
                parentItem.time = time.substr(8, 8);

                const commentContent = parentItem.comment_contents;

                parentItem.contents = resolveFace(commentContent);

                const uname = parentItem.uname;

                if (uname === '客户端用户' || uname === '手机用户' || uname === '凤凰网友') {
                    parentItem.user_url = '';
                }
                moreParentList.push(parentItem);
            }
            item.moreParentList = moreParentList;
        }
    });

    return data;
};

// 获取评论数据
const getHotList = async (getUrl, docUrl, sKey, page = 1, pageSize, replyLimit, order) => {
    const data = await jsonp(getUrl, {
        data: {
            orderby: order ? order : 'uptimes',
            docUrl,
            format: 'js',
            job: 1,
            p: page,
            pageSize,
            skey: sKey,
        },
        jsonpCallback: 'newCommentListCallBack',
        cache: true,
    });

    // 格式化评论数据
    data.comments = formatHotListData(data.comments, replyLimit);

    return data;
};

/**
 * 获取即发即显评论
 * @param {String} doc_url
 */
const getTempCommentList = async (doc_url, replyLimit) => {
    const data = await jsonp('//comment.ifeng.com/get/tempcomment', {
        data: {
            doc_url,
            format: 'js',
        },
        jsonpCallback: 'getTempComments',
        cache: false,
    });

    // 格式化评论数据
    return formatHotListData(data, replyLimit);
};

// 评论推荐投票
const vote = async (cmtVoteUrl, comment_id, docUrl) => {
    const data = await jsonp(cmtVoteUrl, {
        data: {
            cmtId: comment_id,
            job: 'up',
            docUrl,
            format: 'js',
        },
        jsonpCallback: 'recmCallback',
    });

    return data;
};

// 提交评论
const postComment = async (content, config, commentId) => {
    const data = await jsonp(config.cmtPostUrl, {
        data: commentId
            ? {
                  docUrl: config.docUrl,
                  docName: config.docTitle,
                  skey: config.skey,
                  format: 'js',
                  content,
                  permalink: config.pcUrl,
                  quoteId: commentId,
              }
            : {
                  docUrl: config.docUrl,
                  docName: config.docTitle,
                  skey: config.skey,
                  format: 'js',
                  content,
                  permalink: config.pcUrl,
              },
        jsonpCallback: 'postCmt',
        cache: false,
    });

    return data;
};

// 提交举报
const postJub = async (jubUrl, comment_id, type, content) => {
    const data = await jsonp(jubUrl, {
        data: {
            comment_id,
            type,
            content,
            format: 'js',
        },
        jsonpCallback: createJsonpCallbackName('reportCallback'),
        cache: true,
    });

    return data;
};

// 发送累计评论弹窗次数
const sendCommentFixAddNum = async (key) => {
    const data = await jsonp(`//survey.news.ifeng.com/api/accumulator?key=${key}&format=js`, {
        cache: false
    });

    return data;
}

// 发送累计评论弹窗次数
const getUserInfoByToken = async () => {
    const data = await jsonp(`https://user.ifeng.com/api/v1/get/userinfobytoken?platform=w&systemid=1`, {
        cache: false
    });

    return data;
}

export { getGuid, getHotList, vote, postComment, postJub, getTempCommentList, sendCommentFixAddNum, getUserInfoByToken };
